/*
 * @Author: pengyong
 * @Date: 2020-11-11 22:20:06
 * @LastEditors: awu
 * @LastEditTime: 2020-11-18 00:32:48
 * @Description: 咨询台接口定义
 * @FilePath: /exhibit/src/api/consulting.js
 */
import axios from "@/utils/axios.js";
import { BASE_URL } from "./config";

// 联系我们
export function contactUs(params) {
    return axios.$post(`${BASE_URL}/exhibition/api/v1/purchaser/exh/contact_us`, params);
}



// WEBPACK FOOTER //
// ./src/api/consulting.js